"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixHPhantomEllipsis = fixHPhantomEllipsis;
const tex_syntax_1 = require("./tex-syntax");
function fixHPhantomEllipsis(tex) {
    return tex.replace(new RegExp(`\\\\hphantom${(0, tex_syntax_1.arg)(4)}`, "g"), (token) => {
        return token.replace(/{\.}|\./g, (token) => {
            if (token === ".") {
                return "{.}";
            }
            return token;
        });
    });
}
